import { render } from "./ViewFilePreview.vue?vue&type=template&id=7a51e756&scoped=true"
import script from "./ViewFilePreview.vue?vue&type=script&lang=js"
export * from "./ViewFilePreview.vue?vue&type=script&lang=js"

import "./ViewFilePreview.vue?vue&type=style&index=0&id=7a51e756&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a51e756"]])

export default __exports__